import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import VehicleDetail from './pages/VehicleDetail';
import Admin from './pages/Admin';
import Header from './components/Header';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import SiteFooter from './components/SiteFooter';
import PlacaFipe from './pages/PlacaFipe';
import Locadora from './pages/Locadora';
import Estoque from './pages/Estoque';
import SellCar from './pages/SellCar';
import About from './pages/About';
import AutomotiveGroupLanding from './pages/AutomotiveGroupLanding';

const GestaoApp = React.lazy(() => import('./features/gestao/GestaoApp'));

function AppRoutes() {
  const location = useLocation();
  const isAutomotiveGroupLanding = location.pathname === '/grupo-whatsapp';

  return (
    <>
      {!isAutomotiveGroupLanding && <Header />}
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/grupo-whatsapp" element={<AutomotiveGroupLanding />} />
        <Route path="/locadora" element={<Locadora />} />
        <Route path="/estoque" element={<Estoque />} />
        <Route path="/venda-seu-carro" element={<SellCar />} />
        <Route path="/sobre" element={<About />} />
        <Route path="/vehicle/:id" element={<VehicleDetail />} />
        <Route path="/login" element={<Login />} />
        <Route path="/teste/placa" element={<PlacaFipe />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/gestao/*"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<div />}>
                <GestaoApp />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
      </Routes>
      {!isAutomotiveGroupLanding && <SiteFooter />}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
